import { create } from 'zustand'

const useLoading = create((set) => ({
	isLoading: false,
	setIsLoading: (value) => set({ isLoading: value }),
}))

export default useLoading
